export default __webpack_public_path__ + "static/media/blockchain-dk.317b1d43.svg";